import Reveal, { Stagger, StaggerItem } from "@/components/motion/Reveal";

const REASONS = [
  { t: "Karnataka Focus", d: "Concentrated operating knowledge within a single state." },
  { t: "Fragmented-to-Strategic Aggregation", d: "Assembly of multiple privately held parcels around larger institutional requirements." },
  { t: "Local Engagement", d: "Direct engagement with landowners and relevant local stakeholders." },
  { t: "Structured Diligence", d: "Legal, revenue-record and documentation review integrated into the transaction process." },
  { t: "Institutional Orientation", d: "Business structured around Government and corporate requirements — not retail property listings." },
  { t: "Long-Term Stewardship", d: "A privately held house established in 1995, presently under second-generation leadership." },
];

export default function WhyRudra() {
  return (
    <section id="why-rudra" data-testid="why-rudra-section" className="relative bg-[#08080A] py-32 md:py-40 border-t border-white/8">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal className="mb-16 max-w-3xl">
          <div className="overline mb-6">Why Rudra Empire</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-neutral-50">
            Six <span className="italic text-[#D4AF37]">characteristics</span> of the house.
          </h2>
        </Reveal>
        <Stagger className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" gap={0.08}>
          {REASONS.map((r, i) => (
            <StaggerItem key={r.t}>
              <div className="border border-white/8 bg-[#121215] p-8 h-full">
                <div className="font-display italic text-3xl text-[#D4AF37]/70 mb-4">0{i+1}</div>
                <div className="font-display text-xl text-neutral-50 mb-3 leading-tight">{r.t}</div>
                <p className="text-neutral-400 text-sm leading-relaxed">{r.d}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
